
import React, {Fragment} from "react";
import {Form, FormListener} from "../form/Form";
import {AdminUser, ListRequest, ListUserGroupResponse, UserGroup} from "../../http/protocol";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {AdminUserService} from "../../services/AdminUserService";
import {getContainer} from "../../ioc/IOCSetup";
import {UserGroupService} from "../../services/UserGroupService";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {LoadingViewState, RouterView} from "../RouterView";
import * as _ from "lodash";
import {Validators} from "../form/Validators";

interface State extends LoadingViewState {
    user? : AdminUser;
    userGroups? : UserGroup[];
    validationMap? : any;
    successText?: string;
    tempPassword? : string;
    resetPasswordInProgress? : boolean;
}

interface Props extends RouteComponentProps {
    service? : AdminUserService;
    groupService? : UserGroupService;
}


export class AdminUserView extends RouterView<Props,State> implements FormListener<AdminUser>{

    service : AdminUserService;
    groupService : UserGroupService;
    constructor(props : Props){
        super(props);
        this.service =  getContainer().getAdminUserService();
        this.groupService =  getContainer().getUserGroupService();
        this.state = { validationMap : {}, loading : true, user : {}, userGroups : [], successText : "", tempPassword : "", resetPasswordInProgress : false};
    }

    loadContent() : Promise<any> | undefined {
        var id = (this.props.match.params as any).id;
        if(id && id!== "new") {
            let listRequest : ListRequest = { limit:1000,offset:0, orderBy : "id", ascending : false };
            return Promise.all<any>([
                this.service.getEntity(id),
                this.groupService.list(listRequest)

            ]).then( res => {
                let user = res[0];
                let groups : ListUserGroupResponse = res[1];
                this.setState({loading : false, user : user, userGroups : groups.items });
            });
        } else {
            this.setState({ user : { groups :[] }});
            return undefined;
        }

    }
    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    onSubmit():Promise<any> {
        if(!this.state.user) {
            return Promise.resolve();
        }
        return this.service.save(this.state.user).then( (user : AdminUser) => {
            let pass = user.password;
            user.password = undefined;

            if((this.props.match.params as any).id === "new") {
                this.setState({user : user, successText : "User was created with password: " + pass})
            } else {
                this.setState({user : user, successText : "User was updated"})
            }

        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
    }
    onSuccessClose() {
        if((this.props.match.params as any).id === "new") {
            this.setState({successText : ""});
            if(this.state.user) {
                this.navigate("/admin/admin-user/"+this.state.user.id);
            }
        }
    }
    onSubmitError(){}

    formDidUpdate(formModel:AdminUser, validationMap : any) {
        this.setState({user : formModel, validationMap : validationMap});
    }

    getFormModel():AdminUser|undefined {
        return this.state.user;
    }

    getTitle() : string {
        return "Edit/Create Admin User";
    }

    toggleNameId(id?: number) {
        if(!id) {
            return;
        }
        var user = this.state.user;
        if(user && user.groups) {
            user  = _.clone(user) as AdminUser;
            var index : number = -1;
            if(user.groups) {
                index = user.groups.indexOf(id);
            }
            if(index !== -1) {
                user.groups && user.groups.splice(index,1)
            } else {
                user.groups && user.groups.push(id);
            }
            this.setState({ user : user });
            console.log(user.groups);
        }
    }
    isEnabled(id : number | undefined) : boolean {
        if(!id || !this.state.user || !this.state.user.groups) {
            return false;
        }
        return this.state.user.groups.indexOf(id) !== -1
    }
    resetPassword() {
        if((this.props.match.params as any).id !== "new") {
            this.setState({resetPasswordInProgress : true});
            if(this.state.user) {
                this.service.resetPassword(this.state.user.id).then( (u : AdminUser) => {
                    this.setState({resetPasswordInProgress : false, tempPassword : u.password})
                }).catch(e => {
                    this.setState({resetPasswordInProgress : false})
                })
            }

        }
    }
    getUserGroups(){
        if(!this.state.userGroups) {
            return <span></span>
        }
        return this.state.userGroups.map( (g : UserGroup) => {
            return (
                <tr key={g.id}>
                    <td><input type="checkbox" checked={this.isEnabled(g.id)} onChange={this.toggleNameId.bind(this,g.id)}/></td>
                    <td>{g.id}</td>
                    <td>{g.name}</td>
                </tr>
            );
        });
    }


    renderContent() {

        return (

            <Fragment>
                    <Form className="form-horizontal" formListener={this} modelObject={this.state.user} validationMap={this.state.validationMap}>
                        <div className={"card"}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <FormSubmitError />
                                        <FormSubmitSuccess text="User was updated successfully"/>

                                        <FormGroup className="form-group mb-3" model="alias">
                                            <label>Alias</label>
                                            <FormInput data-testid="alias" className="form-control" model="alias" type="text" />
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="email">
                                            <label>E-mail</label>
                                            <FormInput data-testid="email" className="form-control" model="email" type="text" validators={[Validators.required(), Validators.email()]}/>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="firstName">
                                            <label>First Name</label>
                                            <FormInput id="firstName" className="form-control" model="firstName" type="text" validators={[Validators.required()]}/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group mb-3" model="lastName">
                                            <label>Last Name</label>
                                            <FormInput id="lastName" className="form-control" model="lastName" type="text" validators={[Validators.required()]}/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="custom-control custom-checkbox" model="blocked">
                                            <FormInput id={"blocked"} className="custom-control-input" model="blocked" type="checkbox"/>
                                            <label htmlFor={"blocked"} className={"custom-control-label"}>Blocked</label>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group" model="password">
                                            <label>Password</label>
                                            <div id="password" className="form-control" style={{paddingTop : "6px"}}>
                                                {(this.props.match.params as any).id === "new" && "Will be generated"}
                                                {(this.props.match.params as any).id !== "new" && this.state.resetPasswordInProgress === true && "Please Wait..."}
                                                {(this.props.match.params as any).id !== "new" && this.state.resetPasswordInProgress === false && this.state.tempPassword === "" && <a href="/#" onClick={(e:any)=> { e.preventDefault(); this.resetPassword();}}>Reset Password</a>}
                                                {(this.props.match.params as any).id !== "new" && this.state.resetPasswordInProgress === false && this.state.tempPassword !== "" && "Temporary password (valid for 24h): " + this.state.tempPassword}
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={"card"}>
                            <div className={"card-body"}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ibox float-e-margins">
                                            <div className="ibox-title">
                                                <h5>User Groups</h5>
                                            </div>
                                            <div className="ibox-content">
                                                <table className="table table-striped dt-responsive nowrap dataTable no-footer dtr-inline">
                                                    <thead>
                                                    <tr>
                                                        <th>Include</th>
                                                        <th>Name Id</th>
                                                        <th>Name</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.getUserGroups()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"card"}>
                            <div className={"card-body"}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ibox float-e-margins">
                                            <div className="ibox-content">
                                                <div className="ibox-title">
                                                    <h5>Actions</h5>
                                                </div>
                                                <FormSubmitError />
                                                <FormSubmitSuccess text={this.state.successText} onClose={()=>this.onSuccessClose()}/>
                                                <div className="form-group">
                                                    <div className="col-sm-10 col-sm-offset-2">
                                                        <Submit id="saveUser" className="btn btn-primary waves-effect waves-light">Save User</Submit>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Form>


            </Fragment>
        )
    }

}

export default withRouter(AdminUserView);